// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__Uk9Ru","content":"style_content__-d7i9","button":"style_button__mtG1p","title":"style_title__KWNaO","info":"style_info__sGe7+"};